import styled, { css } from 'styled-components'

export const Img = styled.img<{ width?: number; height?: number }>`
    height: auto;
    max-width: 100%;

    ${({ width, height }) =>
        height &&
        width &&
        css`
            aspect-ratio: ${width} / ${height};
        `}
`
